import { __platform_browser_private__ } from '@angular/platform-browser';
var getDOM: () => any = (<any>__platform_browser_private__).getDOM;
export { getDOM }

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
